import React from "react";
import { motion } from "framer-motion";
import {
  FaReact,
  FaCode,
  FaUserTie,
  FaMobileAlt,
  FaServer,
  FaCloudUploadAlt,
} from "react-icons/fa";

const serviceList = [
  {
    id: 1,
    title: "Frontend Architecture & Leadership",
    description:
      "Leading frontend teams and establishing architectural patterns for scalable React and React Native applications. Driving technical excellence through code reviews, mentorship, and best practices.",
    icon: <FaUserTie />,
    features: [
      "Technical Leadership",
      "Architecture Design",
      "Team Mentorship",
      "Code Quality Standards",
    ],
  },
  {
    id: 2,
    title: "React & React Native Development",
    description:
      "Building high-performance web and mobile applications using React, React Native, Vue, and modern JavaScript frameworks. Specializing in component-driven architecture and state management.",
    icon: <FaReact />,
    features: [
      "React Web Applications",
      "React Native Mobile Apps",
      "Vue & Nuxt.js",
      "Progressive Web Apps",
    ],
  },
  {
    id: 3,
    title: "Full-Stack Development",
    description:
      "Developing complete solutions from frontend to backend using modern tech stacks. Expert in Node.js, Laravel, and integrating various APIs and services.",
    icon: <FaCode />,
    features: [
      "Node.js & Express",
      "Laravel Backend",
      "RESTful APIs",
      "Database Design",
    ],
  },
  {
    id: 4,
    title: "Mobile Solutions",
    description:
      "Creating cross-platform mobile applications with React Native for iOS and Android. Building fintech and banking solutions with focus on security and performance.",
    icon: <FaMobileAlt />,
    features: [
      "iOS Development",
      "Android Development",
      "Cross-Platform Apps",
      "Banking & Fintech",
    ],
  },
  {
    id: 5,
    title: "Backend & API Development",
    description:
      "Building robust, scalable backend systems with Node.js, Laravel, and modern databases. Creating secure APIs with authentication and authorization.",
    icon: <FaServer />,
    features: [
      "RESTful APIs",
      "MongoDB & Firebase",
      "Authentication & Security",
      "Microservices",
    ],
  },
  {
    id: 6,
    title: "Cloud & DevOps",
    description:
      "Deploying and managing applications on AWS and other cloud platforms. Implementing CI/CD pipelines and ensuring scalable infrastructure.",
    icon: <FaCloudUploadAlt />,
    features: [
      "AWS Services",
      "CI/CD Pipelines",
      "Cloud Architecture",
      "Performance Optimization",
    ],
  },
];

const Services = () => {
  return (
    <motion.section
      className="section services-modern"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="section-title">
        <h2>What I Do</h2>
        <div className="underline"></div>
        <p className="services-subtitle">
          Technical leadership and full-stack development services focused on
          scalable, high-performance solutions
        </p>
      </div>

      <div className="services-grid-modern">
        {serviceList.map((service, index) => (
          <motion.article
            key={service.id}
            className="service-card-modern"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="service-card-inner">
              <div className="service-icon-modern">{service.icon}</div>

              <h3 className="service-title-modern">{service.title}</h3>

              <p className="service-description-modern">
                {service.description}
              </p>

              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="feature-bullet">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </motion.article>
        ))}
      </div>
    </motion.section>
  );
};

export default Services;
